import React from "react";
import { AHText, Box } from "arkh";
import { Image } from "react-native";
import { FormattedMessage } from "react-intl";

const TeamScheduleEmptyCopy = {
  title: (
    <FormattedMessage
      defaultMessage="Routines"
      description="RoutinesScheduleEmpty Title"
    />
  ),
  subtitle: (
    <FormattedMessage
      defaultMessage="Organise daily, weekly and monthly routines here."
      description="RoutinesScheduleEmpty Subtitle"
    />
  ),
};

export function TeamScheduleEmpty() {
  return (
    <Box spaceHorizontal="medium">
      <Box color="surface" space="medium" cornerRadius="large">
        <AHText type="title-small">{TeamScheduleEmptyCopy.title}</AHText>
        <AHText type="list-item-title" spaceTop="small">
          {TeamScheduleEmptyCopy.subtitle}
        </AHText>
        <Box spaceBottom="medium">
          <Image
            style={{
              width: "100%",
              height: 180,
            }}
            resizeMode="contain"
            source={require("./teamScheduleCart.png")}
          />
        </Box>
      </Box>
    </Box>
  );
}
